export default __webpack_public_path__ + "static/media/save.9a6ab463.svg";